/* =========================================================
   CONFIG
   ========================================================= */
const JSONBIN_BASE = 'https://api.jsonbin.io/v3/b';

/* =========================================================
   LOGO
   ========================================================= */
// Logo URL is injected via window.LOGO_URL from the Liquid template
document.getElementById('brandLogo').src = window.LOGO_URL || '';

/* =========================================================
   SPECTRUM DATA (same as main spectrum scorer)
   ========================================================= */
const QUADRANTS = [
  { key: 'purple', name: 'Purple', color: '#6b3fa0', textDark: false, labelColor: '#6b3fa0' },
  { key: 'white',  name: 'White',  color: '#c8b878', textDark: true,  labelColor: '#8b7a3a' },
  { key: 'yellow', name: 'Yellow', color: '#e6a93b', textDark: true,  labelColor: '#b07820' },
  { key: 'red',    name: 'Red',    color: '#c8362b', textDark: false, labelColor: '#c8362b' }
];

const SPECTRUM = [
  { name: 'Blackberry',     color: '#3b1f3a', quad: 'purple' },
  { name: 'Blueberry',      color: '#4a3b8a', quad: 'purple' },
  { name: 'Black Currant',  color: '#3a1a3f', quad: 'purple' },
  { name: 'Mulberry',       color: '#5a3060', quad: 'purple' },
  { name: 'Dark Grape',     color: '#5a2e6e', quad: 'purple' },
  { name: 'Dark Plum',      color: '#5e2050', quad: 'purple' },
  { name: 'Fig',            color: '#6b3a4a', quad: 'purple' },
  { name: 'Date',           color: '#5a3a28', quad: 'purple' },
  { name: 'Prune',          color: '#4a2438', quad: 'purple' },
  { name: 'Raisin',         color: '#5a3020', quad: 'purple' },
  { name: 'Red Wine',       color: '#6a1a2a', quad: 'purple' },
  { name: 'Port',           color: '#6e2238', quad: 'purple' },
  { name: 'Rum',            color: '#7a3a1f', quad: 'purple' },
  { name: 'Cacao Nib',      color: '#4a2618', quad: 'purple' },
  { name: 'Dark Chocolate', color: '#3a2418', quad: 'purple' },
  { name: 'Licorice',       color: '#1f1a1a', quad: 'purple' },
  { name: 'Star Anise',     color: '#2a1f24', quad: 'purple' },
  { name: 'Clove',          color: '#5e3a1a', quad: 'purple' },
  { name: 'Cinnamon',       color: '#8b4a1a', quad: 'purple' },
  { name: 'Pepper',         color: '#3a2a28', quad: 'purple' },
  { name: 'Black Tea',      color: '#8b6b4f', quad: 'white'  },
  { name: 'Bergamot',       color: '#c8d8a5', quad: 'white'  },
  { name: 'Lavender',       color: '#b8a0d6', quad: 'white'  },
  { name: 'Elderflower',    color: '#e8e0c0', quad: 'white'  },
  { name: 'Violet',         color: '#a085c4', quad: 'white'  },
  { name: 'Jasmine',        color: '#f5f0d8', quad: 'white'  },
  { name: 'Orchid',         color: '#d8c5e0', quad: 'white'  },
  { name: 'Magnolia',       color: '#f0e8d0', quad: 'white'  },
  { name: 'Lemongrass',     color: '#c5d68a', quad: 'white'  },
  { name: 'Coffee Blossom', color: '#e8e4d0', quad: 'white'  },
  { name: 'White Tea',      color: '#dcd8b8', quad: 'white'  },
  { name: 'Champagne',      color: '#e8dcb0', quad: 'white'  },
  { name: 'White Wine',     color: '#dcd090', quad: 'white'  },
  { name: 'White Grape',    color: '#c8d090', quad: 'white'  },
  { name: 'White Peach',    color: '#f0c8a8', quad: 'white'  },
  { name: 'White Sugar',    color: '#f0eadc', quad: 'white'  },
  { name: 'Cane Sugar',     color: '#e8d8a0', quad: 'white'  },
  { name: 'Honeydew',       color: '#c8d890', quad: 'white'  },
  { name: 'Pear',           color: '#bcc878', quad: 'white'  },
  { name: 'Lemonade',       color: '#e8dc78', quad: 'white'  },
  { name: 'Green Apple',    color: '#a8c060', quad: 'yellow' },
  { name: 'Lime',           color: '#a8c038', quad: 'yellow' },
  { name: 'Kiwi',           color: '#90a838', quad: 'yellow' },
  { name: 'Starfruit',      color: '#d0c068', quad: 'yellow' },
  { name: 'Citrus Blossom', color: '#b8c850', quad: 'yellow' },
  { name: 'Chamomile',      color: '#c8b860', quad: 'yellow' },
  { name: 'Green Tea',      color: '#7a8a4a', quad: 'yellow' },
  { name: 'Jackfruit',      color: '#c8a838', quad: 'yellow' },
  { name: 'Pineapple',      color: '#d8b830', quad: 'yellow' },
  { name: 'Passion Fruit',  color: '#c0a020', quad: 'yellow' },
  { name: 'Mango',          color: '#e0a020', quad: 'yellow' },
  { name: 'Apricot',        color: '#e09848', quad: 'yellow' },
  { name: 'Nectarine',      color: '#e08840', quad: 'yellow' },
  { name: 'Yellow Peach',   color: '#e0a058', quad: 'yellow' },
  { name: 'Yellow Plum',    color: '#c89048', quad: 'yellow' },
  { name: 'Honey',          color: '#c8951f', quad: 'yellow' },
  { name: 'Sultana',        color: '#a87838', quad: 'yellow' },
  { name: 'Caramel',        color: '#a8702a', quad: 'yellow' },
  { name: 'Toffee',         color: '#8b5a28', quad: 'yellow' },
  { name: 'Malt',           color: '#7a4a20', quad: 'yellow' },
  { name: 'Brown Sugar',    color: '#7a4828', quad: 'red'    },
  { name: 'Molasses',       color: '#5a3018', quad: 'red'    },
  { name: 'Milk Chocolate', color: '#7a4a30', quad: 'red'    },
  { name: 'Grapefruit',     color: '#d8704a', quad: 'red'    },
  { name: 'Mandarin',       color: '#d86028', quad: 'red'    },
  { name: 'Orange',         color: '#d85820', quad: 'red'    },
  { name: 'Blood Orange',   color: '#b83820', quad: 'red'    },
  { name: 'Tangerine',      color: '#d8703a', quad: 'red'    },
  { name: 'Papaya',         color: '#d86840', quad: 'red'    },
  { name: 'Guava',          color: '#c84858', quad: 'red'    },
  { name: 'Pomegranate',    color: '#a8202a', quad: 'red'    },
  { name: 'Cherry',         color: '#a01820', quad: 'red'    },
  { name: 'Red Apple',      color: '#b82820', quad: 'red'    },
  { name: 'Red Grape',      color: '#8a1830', quad: 'red'    },
  { name: 'Red Plum',       color: '#a02838', quad: 'red'    },
  { name: 'Cranberry',      color: '#a01828', quad: 'red'    },
  { name: 'Strawberry',     color: '#c82838', quad: 'red'    },
  { name: 'Raspberry',      color: '#b8203a', quad: 'red'    },
  { name: 'Watermelon',     color: '#c83a48', quad: 'red'    },
  { name: 'Rose',           color: '#c04878', quad: 'red'    },
  { name: 'Hibiscus',       color: '#a82048', quad: 'red'    }
];

/* =========================================================
   STATE
   ========================================================= */
const state = {
  binId: null,
  session: null,           // full session object loaded from JSONBin
  cupperName: '',
  currentCoffeeId: null,   // when scoring
  current: null,           // current scoring draft {notes, impression, cupperNotes}
  zoomedQuad: null
};

/* =========================================================
   HELPERS
   ========================================================= */
const $ = (id) => document.getElementById(id);
const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const getQuadrant = (key) => QUADRANTS.find(q => q.key === key);
function formatDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }).toUpperCase(); }
  catch { return iso; }
}
function getOriginDisplay(c) {
  if (c.origin === '__manual__') return c.originManual || '';
  return c.origin || '';
}
function getUseDisplay(c) {
  if (c.use === '__manual__') return c.useManual || '';
  return c.use || '';
}
function getCoffeeMeta(c) {
  const parts = [];
  const o = getOriginDisplay(c);
  if (o) parts.push(o);
  if (c.brew) parts.push(c.brew);
  const u = getUseDisplay(c);
  if (u) parts.push(u);
  return parts.join(' · ');
}

function polarToCartesian(cx, cy, r, angleDeg) {
  const a = (angleDeg - 90) * Math.PI / 180;
  return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
}
function arcPath(cx, cy, rInner, rOuter, startAngle, endAngle) {
  const p1 = polarToCartesian(cx, cy, rOuter, startAngle);
  const p2 = polarToCartesian(cx, cy, rOuter, endAngle);
  const p3 = polarToCartesian(cx, cy, rInner, endAngle);
  const p4 = polarToCartesian(cx, cy, rInner, startAngle);
  const large = (endAngle - startAngle) > 180 ? 1 : 0;
  return [
    `M ${p1.x} ${p1.y}`,
    `A ${rOuter} ${rOuter} 0 ${large} 1 ${p2.x} ${p2.y}`,
    `L ${p3.x} ${p3.y}`,
    `A ${rInner} ${rInner} 0 ${large} 0 ${p4.x} ${p4.y}`,
    'Z'
  ].join(' ');
}
function bandArcPath(cx, cy, r, startAngle, endAngle) {
  const p1 = polarToCartesian(cx, cy, r, startAngle);
  const p2 = polarToCartesian(cx, cy, r, endAngle);
  const large = (endAngle - startAngle) > 180 ? 1 : 0;
  return `M ${p1.x} ${p1.y} A ${r} ${r} 0 ${large} 1 ${p2.x} ${p2.y}`;
}
function colorLuminance(hex) {
  const c = hex.replace('#','');
  const r = parseInt(c.substring(0,2), 16) / 255;
  const g = parseInt(c.substring(2,4), 16) / 255;
  const b = parseInt(c.substring(4,6), 16) / 255;
  return 0.299*r + 0.587*g + 0.114*b;
}

/* =========================================================
   SCORE COMPUTATION (matches host calculation)
   ========================================================= */
function computeScore(draft) {
  if (!draft) return { total: 0, manual: false };
  // Manual override
  if (draft.manualScore !== null && draft.manualScore !== undefined && draft.manualScore !== '') {
    const m = parseFloat(draft.manualScore);
    if (!isNaN(m)) {
      return { total: Math.max(0, Math.min(100, m)), manual: true };
    }
  }
  const impressionPts = (draft.impression / 10) * 40;
  const complexityPts = Math.min(draft.notes.length * 3, 25);
  let intensityPts = 0;
  if (draft.notes.length > 0) {
    const avgI = draft.notes.reduce((a,n)=>a + n.intensity, 0) / draft.notes.length;
    const distance = Math.abs(avgI - 3);
    const quality = Math.max(0, 1 - distance / 2);
    intensityPts = quality * 20;
  }
  const distinctQuads = new Set(draft.notes.map(n => n.quad)).size;
  const balancePts = Math.min(distinctQuads * 3.75, 15);
  const total = impressionPts + complexityPts + intensityPts + balancePts;
  return { total: Math.max(0, Math.min(100, total)), manual: false };
}
function gradeFor(score) {
  if (score >= 90) return { label: 'Outstanding · 90+', specialty: true };
  if (score >= 85) return { label: 'Excellent · 85–89.99', specialty: true };
  if (score >= 80) return { label: 'Specialty · 80–84.99', specialty: true };
  if (score >= 70) return { label: 'Below Specialty', specialty: false };
  if (score >= 60) return { label: 'Commercial', specialty: false };
  return { label: 'Off-grade', specialty: false };
}

/* =========================================================
   JSONBIN (READ public + WRITE via Access Key)
   For cupper file we don't have the master key; we use public bin access.
   Read: no auth needed for public bins.
   Write: we need to be able to PUT, which requires X-Access-Key OR
   the bin owner must allow updates without auth (public bins ARE writeable without auth).
   ========================================================= */
async function jbRead(binId) {
  const r = await fetch(`${JSONBIN_BASE}/${binId}/latest`, { method: 'GET' });
  if (!r.ok) throw new Error('Read failed: ' + r.status);
  const data = await r.json();
  return data.record;
}

async function jbUpdate(binId, payload) {
  const r = await fetch(`${JSONBIN_BASE}/${binId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!r.ok) {
    const text = await r.text();
    throw new Error('Update failed: ' + r.status + ' ' + text);
  }
  return await r.json();
}

/* =========================================================
   SCREEN MANAGEMENT
   ========================================================= */
function showScreen(name) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  $('screen-' + name).classList.add('active');
}

/* =========================================================
   SESSION LOAD
   ========================================================= */
async function loadSession() {
  // Parse bin id from URL ?s=...
  const url = new URL(window.location.href);
  const binId = url.searchParams.get('s');

  if (!binId) {
    $('errorTitle').textContent = 'No session in link';
    $('errorMessage').textContent = 'This page should be opened from a link the host shared with you.';
    showScreen('error');
    return;
  }

  state.binId = binId;
  try {
    const session = await jbRead(binId);
    if (!session || session.type !== '48east-cupping-session') {
      $('errorTitle').textContent = 'Invalid session';
      $('errorMessage').textContent = 'This link does not point to a valid cupping session.';
      showScreen('error');
      return;
    }
    state.session = session;

    if (session.status === 'closed') {
      showScreen('closed');
      return;
    }

    // Update topbar
    $('topbarSession').textContent = session.name || '';

    // Restore cupper name from localStorage scoped to this bin
    const savedName = localStorage.getItem('cupper-name:' + binId) || '';
    if (savedName) {
      state.cupperName = savedName;
      enterListView();
    } else {
      showWelcome();
    }
  } catch (e) {
    console.error(e);
    $('errorTitle').textContent = 'Could not load session';
    $('errorMessage').textContent = 'Check your internet connection and the link, then try again.';
    $('errorCode').textContent = String(e.message || e);
    $('errorCode').style.display = 'inline-block';
    showScreen('error');
  }
}

/* =========================================================
   WELCOME / NAME
   ========================================================= */
function showWelcome() {
  const s = state.session;
  $('welcomeSessionName').innerHTML = escapeHtml(s.name || '').replace(/\b(\w+)$/, '<em>$1</em>') || 'Session';
  const parts = [];
  if (s.date) parts.push(formatDate(s.date));
  if (s.host) parts.push('Hosted by ' + escapeHtml(s.host));
  if (s.location) parts.push(escapeHtml(s.location));
  parts.push((s.coffees || []).length + ' coffees to score');
  $('welcomeSessionInfo').innerHTML = parts.join(' &nbsp;·&nbsp; ');
  $('cupperNameInput').value = '';
  $('startCuppingBtn').disabled = true;
  showScreen('welcome');
  setTimeout(() => $('cupperNameInput').focus(), 100);
}

function bindWelcome() {
  const input = $('cupperNameInput');
  const btn = $('startCuppingBtn');
  input.addEventListener('input', () => {
    btn.disabled = input.value.trim().length < 2;
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !btn.disabled) startCupping();
  });
  btn.addEventListener('click', startCupping);
}

function startCupping() {
  const name = $('cupperNameInput').value.trim();
  if (name.length < 2) return;
  state.cupperName = name;
  localStorage.setItem('cupper-name:' + state.binId, name);
  enterListView();
}

function changeCupper() {
  if (!confirm('Switch cupper? Your name will be cleared but submissions you already made remain in the session.')) return;
  state.cupperName = '';
  localStorage.removeItem('cupper-name:' + state.binId);
  showWelcome();
}

/* =========================================================
   COFFEE LIST
   ========================================================= */
function enterListView() {
  // Update top cupper badge
  $('cupperBadge').style.display = '';
  $('cupperBadgeName').textContent = state.cupperName;

  // Session banner
  const s = state.session;
  $('listSessionName').textContent = s.name || '—';
  const parts = [];
  if (s.date) parts.push(formatDate(s.date));
  if (s.host) parts.push(s.host);
  if (s.location) parts.push(s.location);
  $('listSessionInfo').textContent = parts.join(' · ');

  renderCoffeeList();
  showScreen('list');
}

function getMySubmissions() {
  return (state.session.submissions || []).filter(s => s.cupperName === state.cupperName);
}
function getMySubmissionForCoffee(coffeeId) {
  return getMySubmissions().find(s => s.coffeeId === coffeeId);
}
function isAllSubmittedLocked() {
  // True when this cupper has submitted for EVERY coffee in the session.
  // Once true, all submissions become read-only (final).
  const coffees = state.session.coffees || [];
  if (coffees.length === 0) return false;
  const my = getMySubmissions();
  return coffees.every(c => my.some(s => s.coffeeId === c.id));
}

function renderCoffeeList() {
  const list = $('coffeeList');
  const coffees = state.session.coffees || [];
  if (coffees.length === 0) {
    list.innerHTML = '<div class="empty-list">No coffees in this session.</div>';
    $('listProgress').textContent = '0 / 0';
    return;
  }

  const my = getMySubmissions();
  $('listProgress').textContent = my.length + ' / ' + coffees.length;

  const allLocked = isAllSubmittedLocked();

  // Show progress / lock state banner above list
  const banner = $('listLockBanner');
  if (banner) {
    if (allLocked) {
      banner.innerHTML = '<strong>All submissions locked</strong> · You have submitted all coffees. Scores are now final and visible to the host.';
      banner.classList.remove('editable');
      banner.classList.add('locked');
      banner.style.display = 'block';
    } else if (my.length > 0) {
      const remaining = coffees.length - my.length;
      banner.innerHTML = `<strong>You can still edit</strong> · ${remaining} coffee${remaining === 1 ? '' : 's'} left to submit. You can re-tap any submitted coffee to update your score until all are submitted.`;
      banner.classList.remove('locked');
      banner.classList.add('editable');
      banner.style.display = 'block';
    } else {
      banner.style.display = 'none';
    }
  }

  list.innerHTML = '';
  coffees.forEach((c, i) => {
    const submission = my.find(s => s.coffeeId === c.id);
    const submitted = !!submission;
    const editable = submitted && !allLocked;
    const meta = getCoffeeMeta(c);

    const card = document.createElement('div');
    card.className = 'coffee-card';
    if (submitted && !editable) card.classList.add('submitted');
    if (editable) card.classList.add('editable');
    card.dataset.coffeeId = c.id;

    let statusHtml;
    if (submitted) {
      if (editable) {
        statusHtml = `<span class="my-score">${submission.score.toFixed(1)}</span><span class="status-badge editable">✓ Edit</span><span class="arrow">→</span>`;
      } else {
        statusHtml = `<span class="my-score">${submission.score.toFixed(1)}</span><span class="status-badge submitted">Submitted</span>`;
      }
    } else {
      statusHtml = `<span class="status-badge pending">Pending</span><span class="arrow">→</span>`;
    }

    card.innerHTML = `
      <div class="coffee-num">${String(i+1).padStart(2,'0')}</div>
      <div class="coffee-info">
        <div class="name">${escapeHtml(c.name)}</div>
        ${meta ? `<div class="meta">${escapeHtml(meta)}</div>` : ''}
      </div>
      <div class="coffee-status">${statusHtml}</div>
    `;
    // Tappable if pending OR (submitted AND not all locked)
    if (!submitted || editable) {
      card.addEventListener('click', () => openScoring(c.id));
    } else if (submitted && allLocked) {
      // still tappable to view in read-only mode
      card.addEventListener('click', () => openScoring(c.id));
    }
    list.appendChild(card);
  });
}

/* =========================================================
   SCORING SCREEN
   ========================================================= */
function openScoring(coffeeId) {
  state.currentCoffeeId = coffeeId;
  // Determine read-only state: only locked when ALL coffees submitted
  const existing = getMySubmissionForCoffee(coffeeId);
  const allLocked = isAllSubmittedLocked();
  const readOnly = allLocked;  // editable until all submitted

  if (existing) {
    state.current = {
      notes: existing.descriptors.map(d => {
        const def = SPECTRUM.find(x => x.name === d.name);
        return {
          name: d.name,
          color: def ? def.color : '#888',
          quad: d.quad,
          intensity: d.intensity || 3
        };
      }),
      impression: existing.impression,
      cupperNotes: existing.cupperNotes || '',
      manualScore: existing.manualScore !== undefined ? existing.manualScore : null,
      readOnly,
      isEdit: true   // editing an existing submission
    };
  } else {
    state.current = {
      notes: [],
      impression: 7.5,
      cupperNotes: '',
      manualScore: null,
      readOnly: false,
      isEdit: false
    };
  }
  state.zoomedQuad = null;

  const coffees = state.session.coffees;
  const idx = coffees.findIndex(c => c.id === coffeeId);
  const coffee = coffees[idx];

  $('scoreEyebrow').textContent = `Coffee ${idx + 1} of ${coffees.length}`;
  $('scoreCoffeeName').textContent = coffee.name;
  $('scoreCoffeeMeta').textContent = getCoffeeMeta(coffee) || '—';

  // Read-only banner (only when fully locked)
  const banner = $('readonlyBanner');
  if (readOnly) {
    banner.innerHTML = '<strong>Locked</strong><br>You have submitted scores for all coffees. Your scores are now final and cannot be changed.';
    banner.style.display = 'block';
  } else if (existing) {
    // Editable existing — show a friendly note
    banner.innerHTML = '<strong>Editing your submission</strong><br>You can still adjust this score until you submit all coffees. Once all are submitted, scores lock.';
    banner.style.display = 'block';
    banner.classList.remove('locked');
    banner.classList.add('editable');
  } else {
    banner.style.display = 'none';
    banner.classList.remove('editable', 'locked');
  }

  $('cupperNotes').value = state.current.cupperNotes;
  $('cupperNotes').disabled = state.current.readOnly;

  // Manual score UI state
  renderManualScoreUI();

  // Submit bar
  if (state.current.readOnly) {
    $('submitBar').style.display = 'none';
  } else {
    $('submitBar').style.display = '';
    if (state.current.isEdit) {
      $('submitInfo').textContent = 'Updating your existing submission. Editable until you submit all coffees.';
      $('submitBtn').textContent = 'Update Score';
    } else {
      $('submitInfo').textContent = 'You can edit this score until all coffees are submitted.';
      $('submitBtn').textContent = 'Submit Score';
    }
    $('submitBtn').disabled = false;
  }

  renderWheel();
  updateImpressionUI();
  renderNotesList();
  refreshScore();
  showScreen('score');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function renderManualScoreUI() {
  const c = state.current;
  if (!c) return;
  const isManual = c.manualScore !== null && c.manualScore !== undefined && c.manualScore !== '';
  $('manualScoreCheck').checked = isManual;
  $('manualScoreCheck').disabled = !!c.readOnly;
  $('manualScoreField').disabled = !!c.readOnly;
  $('manualScoreField').value = isManual ? c.manualScore : '';
  $('manualScoreInput').classList.toggle('show', isManual);
  $('scorePreview').classList.toggle('is-manual', isManual);
  // Hide the toggle entirely when read-only (no point showing a disabled toggle)
  $('manualToggleRow').style.display = c.readOnly ? 'none' : '';
}

/* =========================================================
   WHEEL
   ========================================================= */
function renderWheel() {
  const svg = $('flavorWheel');
  svg.innerHTML = '';
  if (state.zoomedQuad) renderWheelZoomed();
  else renderWheelFull();

  svg.querySelectorAll('.arc[data-name]').forEach(arc => {
    arc.addEventListener('click', () => onWheelClick(arc));
  });
  svg.querySelectorAll('[data-quad-zoom]').forEach(el => {
    el.addEventListener('click', () => {
      state.zoomedQuad = el.dataset.quadZoom;
      renderWheel();
      updateZoomBar();
    });
  });
  const exitArea = svg.querySelector('.dial-exit');
  if (exitArea) {
    exitArea.addEventListener('click', () => {
      state.zoomedQuad = null;
      renderWheel();
      updateZoomBar();
    });
  }
  applyWheelSelection();
  updateZoomBar();
}

function renderWheelFull() {
  const svg = $('flavorWheel');
  const cx = 50, cy = 50;
  const rInner = 17, rOuter = 42, rBand = 47;
  const total = SPECTRUM.length;
  const step = 360 / total;

  SPECTRUM.forEach((d, i) => {
    const a1 = i * step, a2 = (i+1) * step;
    const path = arcPath(cx, cy, rInner, rOuter, a1, a2);
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    el.setAttribute('d', path);
    el.setAttribute('fill', d.color);
    el.setAttribute('class', 'arc');
    el.dataset.name = d.name;
    el.dataset.color = d.color;
    el.dataset.quad = d.quad;
    svg.appendChild(el);

    const mid = (a1 + a2) / 2;
    const lr = (rInner + rOuter) / 2;
    const lp = polarToCartesian(cx, cy, lr, mid);
    const lbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    lbl.setAttribute('x', lp.x);
    lbl.setAttribute('y', lp.y);
    lbl.setAttribute('class', 'arc-label');
    let rot = mid > 180 ? mid + 90 : mid - 90;
    lbl.setAttribute('transform', `rotate(${rot} ${lp.x} ${lp.y})`);
    const maxLen = 22;
    const est = (t, fs) => t.length * 0.55 * fs;
    let fs = 2.2;
    if (est(d.name, fs) > maxLen) fs = 2.0;
    if (est(d.name, fs) > maxLen) fs = 1.8;
    if (est(d.name, fs) > maxLen) fs = 1.6;
    const lum = colorLuminance(d.color);
    lbl.setAttribute('fill', lum < 0.55 ? '#ffffff' : '#000000');
    lbl.setAttribute('style', `font-size:${fs}px;`);
    lbl.textContent = d.name;
    svg.appendChild(lbl);
  });

  const quadSpans = {};
  QUADRANTS.forEach(q => quadSpans[q.key] = { start: null, end: null });
  SPECTRUM.forEach((d, i) => {
    const a1 = i * step, a2 = (i+1) * step;
    if (quadSpans[d.quad].start === null) quadSpans[d.quad].start = a1;
    quadSpans[d.quad].end = a2;
  });
  QUADRANTS.forEach(q => {
    const span = quadSpans[q.key];
    if (span.start === null) return;
    const band = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    const gap = 1.2;
    band.setAttribute('d', bandArcPath(cx, cy, rBand, span.start + gap, span.end - gap));
    band.setAttribute('class', 'quad-band');
    band.setAttribute('stroke', q.color);
    band.dataset.quadZoom = q.key;
    svg.appendChild(band);

    const mid = (span.start + span.end) / 2;
    const lr = rBand + 4.5;
    const lp = polarToCartesian(cx, cy, lr, mid);
    const lbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    lbl.setAttribute('x', lp.x);
    lbl.setAttribute('y', lp.y);
    lbl.setAttribute('class', 'quad-label');
    lbl.setAttribute('fill', q.labelColor || q.color);
    lbl.setAttribute('style', 'font-size:3.2px;');
    let rot = mid;
    if (rot > 90 && rot < 270) rot -= 180;
    lbl.setAttribute('transform', `rotate(${rot} ${lp.x} ${lp.y})`);
    lbl.textContent = q.name;
    lbl.dataset.quadZoom = q.key;
    svg.appendChild(lbl);
  });
  renderDial(cx, cy, rInner, false);
}

function renderWheelZoomed() {
  const svg = $('flavorWheel');
  const cx = 50, cy = 50;
  const rInner = 17, rOuter = 46;
  const quad = getQuadrant(state.zoomedQuad);
  if (!quad) return;
  const descriptors = SPECTRUM.filter(d => d.quad === state.zoomedQuad);
  const total = descriptors.length;
  const step = 360 / total;

  descriptors.forEach((d, i) => {
    const a1 = i * step, a2 = (i+1) * step;
    const path = arcPath(cx, cy, rInner, rOuter, a1, a2);
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    el.setAttribute('d', path);
    el.setAttribute('fill', d.color);
    el.setAttribute('class', 'arc');
    el.dataset.name = d.name;
    el.dataset.color = d.color;
    el.dataset.quad = d.quad;
    svg.appendChild(el);

    const mid = (a1 + a2) / 2;
    const lr = (rInner + rOuter) / 2;
    const lp = polarToCartesian(cx, cy, lr, mid);
    const lbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    lbl.setAttribute('x', lp.x);
    lbl.setAttribute('y', lp.y);
    lbl.setAttribute('class', 'arc-label');
    let rot = mid > 180 ? mid + 90 : mid - 90;
    lbl.setAttribute('transform', `rotate(${rot} ${lp.x} ${lp.y})`);
    const maxLen = 28;
    const est = (t, fs) => t.length * 0.55 * fs;
    let fs = 4.0;
    if (est(d.name, fs) > maxLen) fs = 3.6;
    if (est(d.name, fs) > maxLen) fs = 3.2;
    if (est(d.name, fs) > maxLen) fs = 2.8;
    const lum = colorLuminance(d.color);
    lbl.setAttribute('fill', lum < 0.55 ? '#ffffff' : '#000000');
    lbl.setAttribute('style', `font-size:${fs}px;`);
    lbl.textContent = d.name;
    svg.appendChild(lbl);
  });
  renderDial(cx, cy, rInner, true);
}

function renderDial(cx, cy, rInner, isZoomed) {
  const svg = $('flavorWheel');
  const ringBg = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  ringBg.setAttribute('cx', cx); ringBg.setAttribute('cy', cy);
  ringBg.setAttribute('r', rInner - 2);
  ringBg.setAttribute('class', 'dial-ring');
  svg.appendChild(ringBg);

  const fill = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  fill.setAttribute('cx', cx); fill.setAttribute('cy', cy);
  fill.setAttribute('r', rInner - 2);
  fill.setAttribute('class', 'dial-fill');
  fill.setAttribute('id', 'dialFill');
  const circ = 2 * Math.PI * (rInner - 2);
  fill.setAttribute('stroke-dasharray', `0 ${circ}`);
  fill.setAttribute('transform', `rotate(-90 ${cx} ${cy})`);
  svg.appendChild(fill);

  const center = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  center.setAttribute('cx', cx); center.setAttribute('cy', cy);
  center.setAttribute('r', rInner - 4);
  center.setAttribute('class', 'dial-center' + (isZoomed ? ' dial-exit' : ''));
  if (isZoomed) center.style.cursor = 'pointer';
  svg.appendChild(center);

  if (isZoomed) {
    const exitLbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    exitLbl.setAttribute('x', cx); exitLbl.setAttribute('y', cy - 1.5);
    exitLbl.style.pointerEvents = 'none';
    exitLbl.setAttribute('font-size', '2.4');
    exitLbl.setAttribute('fill', '#000');
    exitLbl.setAttribute('text-anchor', 'middle');
    exitLbl.setAttribute('font-weight', '600');
    exitLbl.setAttribute('letter-spacing', '0.15em');
    exitLbl.textContent = '← EXIT';
    svg.appendChild(exitLbl);

    const quad = getQuadrant(state.zoomedQuad);
    const qLbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    qLbl.setAttribute('x', cx); qLbl.setAttribute('y', cy + 3);
    qLbl.setAttribute('text-anchor', 'middle');
    qLbl.setAttribute('font-size', '2.6');
    qLbl.setAttribute('font-weight', '700');
    qLbl.setAttribute('letter-spacing', '0.2em');
    qLbl.setAttribute('fill', quad.labelColor || quad.color);
    qLbl.style.pointerEvents = 'none';
    qLbl.textContent = quad.name.toUpperCase();
    svg.appendChild(qLbl);
  } else {
    const lblTop = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    lblTop.setAttribute('x', cx); lblTop.setAttribute('y', cy - 8);
    lblTop.setAttribute('class', 'dial-label-top');
    lblTop.textContent = 'Score';
    svg.appendChild(lblTop);

    const scoreText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    scoreText.setAttribute('x', cx); scoreText.setAttribute('y', cy + 0.5);
    scoreText.setAttribute('class', 'dial-score');
    scoreText.setAttribute('id', 'dialScore');
    scoreText.textContent = '75.0';
    svg.appendChild(scoreText);

    const lblBot = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    lblBot.setAttribute('x', cx); lblBot.setAttribute('y', cy + 8);
    lblBot.setAttribute('class', 'dial-label-bottom');
    lblBot.setAttribute('id', 'dialGrade');
    lblBot.textContent = 'Below Specialty';
    svg.appendChild(lblBot);
  }
}

function updateZoomBar() {
  const bar = $('zoomBar');
  if (state.zoomedQuad) {
    const q = getQuadrant(state.zoomedQuad);
    bar.classList.add('show');
    $('zoomSwatch').style.background = q.color;
    $('zoomLabel').textContent = q.name + ' Quadrant';
    $('zoomLabel').style.color = q.labelColor || q.color;
  } else {
    bar.classList.remove('show');
  }
}

function onWheelClick(arc) {
  if (state.current.readOnly) return;
  const name = arc.dataset.name;
  const color = arc.dataset.color;
  const quad = arc.dataset.quad;
  const existingIdx = state.current.notes.findIndex(n => n.name === name);
  if (existingIdx >= 0) state.current.notes.splice(existingIdx, 1);
  else state.current.notes.push({ name, color, quad, intensity: 3 });
  applyWheelSelection();
  renderNotesList();
  refreshScore();
}

function applyWheelSelection() {
  document.querySelectorAll('.wheel-svg .arc[data-name]').forEach(arc => {
    const name = arc.dataset.name;
    const sel = state.current.notes.some(n => n.name === name);
    arc.classList.toggle('selected', sel);
  });
}

/* =========================================================
   IMPRESSION SLIDER
   ========================================================= */
function bindImpressionSlider() {
  const track = $('impressionTrack');
  let dragging = false;
  const handle = (clientX) => {
    if (state.current && state.current.readOnly) return;
    const r = track.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
    const raw = 1 + pct * 9;
    state.current.impression = Math.round(raw * 10) / 10;
    updateImpressionUI();
    refreshScore();
  };
  track.addEventListener('mousedown', e => { dragging = true; handle(e.clientX); });
  track.addEventListener('touchstart', e => { dragging = true; handle(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('mousemove', e => { if (dragging) handle(e.clientX); });
  window.addEventListener('touchmove', e => { if (dragging) handle(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('mouseup', () => dragging = false);
  window.addEventListener('touchend', () => dragging = false);
}
function updateImpressionUI() {
  const v = state.current.impression;
  const pct = ((v - 1) / 9) * 100;
  $('impressionFill').style.width = pct + '%';
  $('impressionThumb').style.left = pct + '%';
  $('impressionVal').textContent = v.toFixed(1) + ' / 10';
}

/* =========================================================
   NOTES LIST
   ========================================================= */
function renderNotesList() {
  const list = $('notesList');
  list.innerHTML = '';
  if (state.current.notes.length === 0) {
    list.innerHTML = '<div class="notes-empty">Tap the wheel to begin tagging</div>';
    $('noteCount').textContent = '0';
    return;
  }
  $('noteCount').textContent = state.current.notes.length;
  state.current.notes.forEach((n, idx) => {
    const q = getQuadrant(n.quad);
    const labelColor = q.labelColor || q.color;
    const item = document.createElement('div');
    item.className = 'note-item';
    const dotsHtml = [1,2,3,4,5].map(i =>
      `<div class="intensity-dot ${i <= n.intensity ? 'on' : ''}" data-i="${i}"></div>`
    ).join('');
    item.innerHTML = `
      <div class="note-color" style="background:${n.color}"></div>
      <div class="note-label">
        <span class="note-name">${escapeHtml(n.name)}</span>
        <span class="note-family" style="color:${labelColor}">${escapeHtml(q.name)}</span>
      </div>
      <div class="intensity-dots" data-idx="${idx}">${dotsHtml}</div>
      ${state.current.readOnly ? '' : '<button class="note-remove" data-rm="' + idx + '">×</button>'}
    `;
    list.appendChild(item);
  });
  if (!state.current.readOnly) {
    list.querySelectorAll('.intensity-dots').forEach(group => {
      const idx = parseInt(group.dataset.idx);
      group.querySelectorAll('.intensity-dot').forEach(dot => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.dataset.i);
          if (state.current.notes[idx].intensity === i && i > 1) {
            state.current.notes[idx].intensity = i - 1;
          } else {
            state.current.notes[idx].intensity = i;
          }
          renderNotesList();
          refreshScore();
        });
      });
    });
    list.querySelectorAll('.note-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.rm);
        state.current.notes.splice(idx, 1);
        renderNotesList();
        applyWheelSelection();
        refreshScore();
      });
    });
  }
}

/* =========================================================
   REFRESH SCORE
   ========================================================= */
function refreshScore() {
  const s = computeScore(state.current);
  const g = gradeFor(s.total);
  $('bigScore').textContent = s.total.toFixed(1);
  $('bigScore').classList.toggle('specialty', g.specialty);
  $('gradeLabel').textContent = g.label;
  $('gradeLabel').classList.toggle('specialty', g.specialty);
  $('scorePreview').classList.toggle('is-manual', !!s.manual);

  const dialFill = $('dialFill');
  if (dialFill) {
    const r = parseFloat(dialFill.getAttribute('r'));
    const c = 2 * Math.PI * r;
    dialFill.setAttribute('stroke-dasharray', `${(s.total / 100) * c} ${c}`);
  }
  const dialScore = $('dialScore');
  if (dialScore) {
    dialScore.textContent = s.total.toFixed(1);
    dialScore.classList.toggle('specialty', g.specialty);
  }
  const dialGrade = $('dialGrade');
  if (dialGrade) dialGrade.textContent = g.label.split(' · ')[0];
}

/* =========================================================
   CUPPER NOTES TEXTAREA
   ========================================================= */
function bindCupperNotes() {
  $('cupperNotes').addEventListener('input', e => {
    if (state.current) state.current.cupperNotes = e.target.value;
  });
}

function bindManualScore() {
  $('manualScoreCheck').addEventListener('change', e => {
    if (!state.current || state.current.readOnly) return;
    if (e.target.checked) {
      // turning on — default to whatever the computed score is, rounded to 0.1
      const computed = computeScore({ ...state.current, manualScore: null }).total;
      state.current.manualScore = computed.toFixed(1);
      $('manualScoreField').value = state.current.manualScore;
    } else {
      state.current.manualScore = null;
    }
    renderManualScoreUI();
    refreshScore();
    setTimeout(() => $('manualScoreField').focus(), 50);
  });
  $('manualScoreField').addEventListener('input', e => {
    if (!state.current || state.current.readOnly) return;
    let v = e.target.value;
    if (v === '') {
      state.current.manualScore = '';
      refreshScore();
      return;
    }
    const n = parseFloat(v);
    if (!isNaN(n)) {
      state.current.manualScore = Math.max(0, Math.min(100, n));
      refreshScore();
    }
  });
}

/* =========================================================
   SUBMIT
   ========================================================= */
async function submitScore() {
  if (!state.current || state.current.readOnly) return;
  const btn = $('submitBtn');
  if (btn.disabled) return;

  const isEdit = state.current.isEdit;

  // Confirm
  const confirmMsg = isEdit
    ? 'Update your score for this coffee? You can keep editing until all coffees are submitted.'
    : 'Submit your score for this coffee? You can edit it until all coffees are submitted.';
  if (!confirm(confirmMsg)) return;

  btn.disabled = true;
  btn.innerHTML = isEdit ? 'Updating…' : 'Submitting…';
  $('submitInfo').textContent = 'Sending to host…';

  const s = computeScore(state.current);
  const submission = {
    cupperName: state.cupperName,
    coffeeId: state.currentCoffeeId,
    score: s.total,
    impression: state.current.impression,
    descriptors: state.current.notes.map(n => ({
      name: n.name,
      quad: n.quad,
      intensity: n.intensity
    })),
    cupperNotes: state.current.cupperNotes,
    manualScore: state.current.manualScore || null,
    isManualScore: s.manual,
    submittedAt: new Date().toISOString()
  };

  try {
    // Re-fetch the session to avoid clobbering other submissions
    const latest = await jbRead(state.binId);

    if (latest.status === 'closed') {
      alert('This session has been closed by the host. Your submission was not recorded.');
      btn.disabled = false;
      btn.textContent = isEdit ? 'Update Score' : 'Submit Score';
      showScreen('closed');
      return;
    }

    // Find existing submission from same cupper + coffee
    latest.submissions = latest.submissions || [];
    const existingIdx = latest.submissions.findIndex(
      x => x.cupperName === state.cupperName && x.coffeeId === state.currentCoffeeId
    );

    // Compute what "all locked" would look like on the latest snapshot.
    // If this is a NEW submission (not edit) AND it would be the cupper's last one,
    // then after this push, isAllSubmittedLocked() becomes true.
    // We don't block; we just inform the cupper.
    const myExisting = latest.submissions.filter(x => x.cupperName === state.cupperName);
    const coffeeIds = latest.coffees.map(c => c.id);
    const otherSubmittedCoffeeIds = myExisting
      .filter(x => x.coffeeId !== state.currentCoffeeId)  // exclude the one we're about to write
      .map(x => x.coffeeId);
    const wouldBeAllLocked = coffeeIds.every(cid => 
      cid === state.currentCoffeeId || otherSubmittedCoffeeIds.includes(cid)
    );

    // If this is the final coffee (would lock everything), ask for stronger confirmation
    if (wouldBeAllLocked && !isAllSubmittedLocked()) {
      const confirmLock = confirm(
        '⚠️  This is your last coffee.\n\n' +
        'Submitting this will lock ALL your scores — none can be edited afterwards.\n\n' +
        'Continue?'
      );
      if (!confirmLock) {
        btn.disabled = false;
        btn.textContent = isEdit ? 'Update Score' : 'Submit Score';
        $('submitInfo').textContent = state.current.isEdit
          ? 'Updating your existing submission. Editable until you submit all coffees.'
          : 'You can edit this score until all coffees are submitted.';
        return;
      }
    }

    // Replace or append
    if (existingIdx >= 0) {
      latest.submissions[existingIdx] = submission;
    } else {
      latest.submissions.push(submission);
    }
    latest.updatedAt = new Date().toISOString();

    await jbUpdate(state.binId, latest);
    state.session = latest;

    showSubmittedScreen();
  } catch (e) {
    console.error(e);
    alert('Submission failed: ' + e.message + '\nPlease try again. If the problem continues, contact the host.');
    btn.disabled = false;
    btn.textContent = isEdit ? 'Update Score' : 'Submit Score';
    $('submitInfo').textContent = state.current.isEdit
      ? 'Updating your existing submission. Editable until you submit all coffees.'
      : 'You can edit this score until all coffees are submitted.';
  }
}

function showSubmittedScreen() {
  const coffees = state.session.coffees;
  const my = getMySubmissions();
  const remaining = coffees.filter(c => !my.find(s => s.coffeeId === c.id));
  const allLocked = remaining.length === 0;

  // Update header text
  const header = document.querySelector('#screen-submitted h2');
  if (header) {
    header.textContent = state.current && state.current.isEdit ? 'Updated' : 'Submitted';
  }

  $('submittedSub').textContent = allLocked
    ? 'All your scores are now final and visible to the host. Thank you!'
    : `${remaining.length} coffee${remaining.length === 1 ? '' : 's'} left. You can still edit your submitted scores until all are submitted.`;

  const nextBtn = $('submittedNextBtn');
  if (remaining.length > 0) {
    nextBtn.style.display = '';
    nextBtn.textContent = 'Next Coffee →';
    nextBtn.onclick = () => openScoring(remaining[0].id);
  } else {
    nextBtn.style.display = 'none';
  }
  showScreen('submitted');
}

/* =========================================================
   INIT
   ========================================================= */
function init() {
  bindWelcome();
  bindImpressionSlider();
  bindCupperNotes();
  bindManualScore();
  $('startCuppingBtn').addEventListener('click', startCupping);
  $('changeCupperBtn').addEventListener('click', changeCupper);
  $('scoreBackBtn').addEventListener('click', () => {
    state.currentCoffeeId = null;
    enterListView();
  });
  $('zoomOutBtn').addEventListener('click', () => {
    state.zoomedQuad = null;
    renderWheel();
    updateZoomBar();
  });
  $('submitBtn').addEventListener('click', submitScore);
  $('submittedListBtn').addEventListener('click', enterListView);
  loadSession();
}

document.addEventListener('DOMContentLoaded', init);